/// <reference path="../_references.ts"/>

module App.Administrative.Inventory {
	import TitleBarService = App.Helpers.TitleBarService;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import Appointment = App.Appointments.Appointment;
	import UserSession = App.User.UserSession;
	import User = App.User.User;

	export class InventorySelectController {
		appointment: Appointment = null;
		searchText: string = '';
		lastSearch: string = '';
		displayFavorites: boolean = false;
		displayCustom: boolean = false;
		displayFilters: boolean = false;
		isSaving: boolean = false;
		inventoryList: InventoryDetails[];
		user: User;

		customInventory: CustomInventory;

		groups: InventoryGroup[] = [];
		categories: InventoryCategory[] = [];
		subCategories: InventorySubCategory[] = [];

		selectedWarehouse: Warehouse = null;
		selectedGroup: InventoryGroup = null;
		selectedCategory: InventoryCategory = null;
		selectedSubCategory: InventorySubCategory = null;

		searching: boolean = false;

		count: number = 0;
		maxPage: number = 1;

		pageSize: number = 25;
		page: number = 1;

		selectedInventory: {
			[key: string]: InventoryDetails
		} = {};

		accordions: {
			[key: string]: boolean
		} = {};

		static $inject: string[] = ['$scope', '$state', '$stateParams', 'TitleBarService', 'SelectedAppointment', 'InventoryService', 'UserSession'];

		constructor(
			private $scope: ng.IScope,
			private $state: ng.ui.IStateService,
			private $stateParams: ng.ui.IStateParamsService,
			private TitleBarService: TitleBarService,
			private SelectedAppointment: SelectedAppointment,
			private InventoryService: InventoryService,
			private UserSession: UserSession
		) {
			const vm = this;

			TitleBarService.set('Appointment');
			vm.selectedWarehouse = vm.$stateParams.selectedWarehouse;

			SelectedAppointment.getAppointment().then((appointment) => {
				vm.setAppointment(appointment);
			});

			UserSession.getUser().then((user) => {
				vm.user = user;
			});

			vm.InventoryService.getInventoryGroups().then((response) => {
				vm.groups = response.data;
			});

			vm.getInventoryList();
		}

		setAppointment(appointment: Appointment): void {
			this.appointment = appointment;
			this.getInventoryList();
		}

		searchChange() {
			if ((this.searchText === '' || this.searchText.length >= 3) && this.searchText !== this.lastSearch) {
				this.getInventoryList();
			}
		}

		setPage(page: number) {
			let newPage = Math.max(1, Math.min(this.maxPage, page));
			if (newPage !== this.page) {
				this.page = newPage;
				this.getInventoryList();
			}
		}

		getItemCount() {
			if (this.count === 0) {
				return '0 - 0 of 0';
			}

			return Math.min(this.count, ((this.page - 1) * this.pageSize) + 1) + ' - ' + Math.min(this.count, this.pageSize * this.page) + ' of ' + this.count;
		}

		updatePageInfo(count: number) {
			this.count = count;
			this.maxPage = Math.max(1, Math.ceil(this.count / this.pageSize));

			return this.maxPage < this.page;
		}

		getInventoryList() {
			const vm = this;
			let params: SearchParams = {
				size: vm.pageSize,
				page: vm.page
			};

			vm.searching = true;

			if(vm.searchText && vm.searchText.length >= 3) {
				this.lastSearch = this.searchText;
				params.search = vm.searchText;
			}

			if(vm.selectedGroup) {
				params.inventory_group = vm.selectedGroup.id;
			}

			if(vm.selectedCategory) {
				params.category = vm.selectedCategory.id;
			}

			if(vm.selectedSubCategory) {
				params.sub_category = vm.selectedSubCategory.id;
			}

			if(vm.selectedWarehouse) {
				params.inventory_sets = vm.selectedWarehouse.inventory_set.id;
			}

			if(vm.displayFavorites) {
				params.favorites = true;
			}

			if(vm.appointment) {
				params.service_request = vm.appointment.service_request.id;
			}

			vm.InventoryService.getInventoryList(params).then((response) => {
				let headers = response.headers();

				if (this.updatePageInfo(Number(headers.count))) {
					this.page = this.maxPage;
					return this.getInventoryList();
				}

				if (vm.inventoryList !== undefined) {
					vm.inventoryList = vm.inventoryList.filter((inventory) => {
						return Object.keys(vm.selectedInventory).find((key: any) => {
							return key === inventory.id.toString();
						}) ? true : false;
					})
				} else {
					vm.inventoryList = [];
				}

				vm.inventoryList = [...vm.inventoryList, ...response.data.filter((inventory) => {
					return !vm.inventoryList.find((inv: any) => {
						return inv.id === inventory.id;
					});
				})];
			}).finally(() => {
				this.searching = false;
			});
		}

		addCustomInventory() {
			if (this.appointment !== null){
				this.customInventory.service_request = this.appointment.service_request.id;
			}
			this.InventoryService.createCustomInventory(this.customInventory).then((response) => {
				this.displayCustom = false;
				this.inventoryList.unshift(response.data);
				this.selectInventory(response.data);
			});
		}

		createInventoryReplenishment() {
			const vm = this;

			vm.isSaving = true;

			let inventories = Object.keys(vm.selectedInventory).map((key) => {
				return {
					quantity: vm.selectedInventory[key].quantity,
					inventory: vm.selectedInventory[key].id
				};
			});

			if (vm.appointment !== null){
				vm.InventoryService.createInventoryReplenishment(vm.appointment.id, {user: vm.user, appointment: vm.appointment.id, inventories: inventories, warehouse: vm.selectedWarehouse.id}).then((response) => {
					vm.$state.go('^');
				}).finally(() => this.isSaving = false);
			} else {
				vm.InventoryService.createIndependentInventoryReplenishment({user: vm.user, inventories: inventories, warehouse: vm.selectedWarehouse.id}).then((response) => {
					vm.$state.go('^');
				}).finally(() => this.isSaving = false);
			}
		}

		selectInventory(inventory: InventoryDetails, manual?: undefined | boolean) {
			const vm = this;
			const quantity = inventory.quantity;

			if(vm.isInventorySelected(inventory) && ((angular.isUndefined(quantity) || quantity === 0 || quantity === null) || manual)) {
				delete vm.selectedInventory[inventory.id];
				inventory.quantity = null;
			} else {
				if(angular.isUndefined(quantity) || quantity === null) {
					inventory.quantity = 1;
				}

				vm.selectedInventory[inventory.id] = angular.copy(inventory);
			}
		}

		hasSelectedInventory(): boolean {
			const vm = this;

			return Object.keys(vm.selectedInventory).length > 0;
		}

		isInventorySelected(inventory: InventoryDetails) {
			return angular.isDefined(this.selectedInventory[inventory.id]);
		}

		removeFilter(type: 'inventoryGroup'|'category'|'subCategory') {
			const vm = this;

			switch(type) {
				case 'subCategory':
					vm.selectedSubCategory = null;
					vm.getInventoryList();
					break;
				case 'category':
					vm.selectedCategory = null;
					vm.selectedSubCategory = null;
					vm.getInventoryList();
					break;
				default:
					vm.clearFilters();
			}
		}

		clearFilters() {
			const vm = this;

			vm.selectedGroup = null;
			vm.selectedCategory = null;
			vm.selectedSubCategory = null;
			vm.categories = [];
			vm.subCategories = [];
			vm.displayFavorites = false;
			vm.searchText = null;

			const keys = Object.keys(vm.accordions);

			keys.forEach((key) => {
				vm.accordions[key] = false;
			});

			vm.accordions.inventoryGroup = true;

			vm.getInventoryList();
		}

		getGroupCategories(group: InventoryGroup) {
			const vm = this;

			vm.searchText = null;
			vm.displayFavorites = false;
			vm.selectedCategory = null;
			vm.selectedSubCategory = null;
			vm.accordions.category = false;
			vm.accordions.subCategory = false;
			vm.categories = [];
			vm.subCategories = [];

			vm.InventoryService.getInventoryCategories(group.id).then((response) => {
				vm.categories = response.data;
				vm.accordions.category = true;
			});

			vm.getInventoryList();
		}

		onSelectSubCategory(subCategory: InventorySubCategory): void {
			const vm = this;

			vm.selectedSubCategory = subCategory;
			vm.searchText = null;
			vm.displayFavorites = false;

			vm.getInventoryList();
		}

		setSubCategories(category: InventoryCategory) {
			const vm = this;

			vm.searchText = null;
			vm.displayFavorites = false;
			vm.selectedSubCategory = null;
			vm.accordions.subCategory = true;

			vm.InventoryService.getInventorySubCategories(category.id).then((response) => {
				vm.subCategories = response.data;
				vm.getInventoryList();
			});
		}

		toggleAccordion(key: string) {
			const vm = this;

			if(angular.isUndefined(vm.accordions[key])) {
				vm.accordions[key] = false;
			}

			vm.accordions[key] = !vm.accordions[key];
		}

		toggleFavorites() {
			this.displayFavorites = !this.displayFavorites;

			this.getInventoryList();
		}

		toggleFilters() {
			this.displayFilters = !this.displayFilters;
		}

		toggleCustomInventory() {
			this.displayCustom = !this.displayCustom;
		}

		toggleInventoryFavorite(inventory: InventoryDetails) {
			const vm = this;

			inventory.favorited = !inventory.favorited;

			if(inventory.favorited) {
				vm.InventoryService.favoriteInventory(inventory.id);
			} else {
				vm.InventoryService.unfavoriteInventory(inventory.id);
			}
		}
 	}
}